// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rL_k6","questions":"styles_questions__1iBzU","footer":"styles_footer__O7QAI"};